<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 14V12H13V14H11ZM7 14V12H9V14H7ZM15 14V12H17V14H15ZM3 22V4H6V2H8V4H16V2H18V4H21V22H3ZM5 20H19V10H5V20Z"
      fill="currentColor"
    />
  </svg>
</template>
